module.exports = {
      id: "outdoor_advertising-usage",
      viewBox: "0 0 353.6 295.72",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#outdoor_advertising-usage",
      toString: function () {
        return this.url;
      }
    }